module.exports = __webpack_public_path__ + "media/EVE.26003145.mp4";